import React from "react";

export const About = ({ data }) => {
  const principles = data ? data.Principles : [];
  const capabilities = data ? data.Capabilities : [];

  return (
    <section id="about" className="section approach-section">
      <div className="section-grid">
        <div className="section-copy">
          <p className="eyebrow">How we work</p>
          <h2>{data ? data.headline : "Useful software, built with taste."}</h2>
          <p>{data ? data.paragraph : "Loading..."}</p>
          <p>{data ? data.paragraph2 : ""}</p>
        </div>
      </div>

      <div className="belief-grid">
        <div>
          <h3>How we build</h3>
          <ul className="check-list">
            {principles.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </div>
        <div>
          <h3>Things we are good at</h3>
          <ul className="check-list">
            {capabilities.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};
